<div class="window">
    <div class="window-header">
        <div class="window-header-label">
            <div class="window-header-label-title">
                {{ title | translate }}
            </div>
        </div>
        <div class="window-header-description">
            <div class="window-header-description-title">
                {{ description | translate }}
            </div>
        </div>
    </div>
    <div class="window-main">
        <ng-content></ng-content>
    </div>
</div>
<div class="overlay">

</div>
